import { createHttpMutationAdapter } from '@/lib/adapters/httpMutationAdapter';

export const httpPostAdapter = createHttpMutationAdapter('post');
